import React, { ReactElement } from 'react'

export function ContactLinkLabelHiddenMobile(props: { label: string }): ReactElement {
  return <div className="hidden font-regular lg:inline-block lg:text-md">{props.label}</div>
}
